import { createContext, useContext, useState, useEffect, useCallback } from 'react'
import { t as translateFn } from './translations'

const STORAGE_KEY = 'wedding-app-lang'
const SUPPORTED_LANGS = ['en', 'es']

const LanguageContext = createContext(null)

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY)
      if (saved && SUPPORTED_LANGS.includes(saved)) return saved
    } catch {}
    return 'en'
  })

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, language)
      document.documentElement.lang = language === 'es' ? 'es' : 'en'
    } catch {}
  }, [language])

  const setLanguage = useCallback((lang) => {
    if (SUPPORTED_LANGS.includes(lang)) {
      setLanguageState(lang)
    }
  }, [])

  const toggleLanguage = useCallback(() => {
    setLanguageState((prev) => (prev === 'en' ? 'es' : 'en'))
  }, [])

  const t = useCallback(
    (key, params) => translateFn(language, key, params),
    [language]
  )

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t,
    isSpanish: language === 'es',
    isEnglish: language === 'en',
  }

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useTranslation() {
  const ctx = useContext(LanguageContext)
  if (!ctx) {
    throw new Error('useTranslation must be used within LanguageProvider')
  }
  return ctx
}
